import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import ProjectsSection from "@/components/ProjectsSection";
import ContactSection from "@/components/ContactSection";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { useVisitorTracking } from "@/hooks/useVisitorTracking";
import { Linkedin } from "lucide-react";

const Index = () => {
  useSmoothScroll();
  useVisitorTracking();
  
  // Load Website Carbon Badge script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/website-carbon-badges@1.1.3/b.min.js';
    script.defer = true;
    document.body.appendChild(script);
    
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <header>
        <Navigation />
      </header>
      
      <main>
        <Hero />
        <ProjectsSection />
        <ContactSection />
      </main>
      
      <footer className="bg-card py-8 border-t">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between">
            <div id="wcb" className="carbonbadge [&_*]:!leading-none [&_*]:!align-middle"></div>
            <p className="text-muted-foreground text-center flex-1">© 2025 Savinien Gicquel - Chef de Projet Digital. Tous droits réservés.</p>
            <a 
              href="https://www.linkedin.com/in/saviniengicquel/" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Profil LinkedIn de Savinien Gicquel"
              className="inline-flex items-center justify-center hover:opacity-70 transition-opacity"
            >
              <Linkedin className="h-6 w-6 text-black" />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};
export default Index;